'use strict';
const mindmupProfile = require('./mindmup-profile'),
	profileDescriptionFromLicense = require('./profile-description-from-license'),
	PROVIDER_NAME = 'one-time-password';
//TODO: split this into separate email authenticator and stored license authenticator
module.exports = function OneTimePasswordAuthenticator(goldApi, authenticationModel, optional) {
	if (!goldApi || !authenticationModel) {
		throw 'invalid-args';
	}
	const self = this,
		saltGenerator = (optional && optional.saltGenerator) || require('./one-time-password');
	let salt,
		currentIdentifier;

	self.requestOneTimePassword = function (identifier) {
		if (!identifier) {
			return Promise.reject('invalid-args');
		}
		salt = saltGenerator();
		currentIdentifier = identifier;
		return goldApi.exec('license/request_code', {'identifier': identifier, 'one_time_pw': salt});
	};

	self.authenticate = function (otp) {
		if (!otp) {
			return Promise.reject('invalid-args');
		}
		if (!salt || !currentIdentifier) {
			return Promise.reject('no-code-requested');
		}
		return goldApi.exec('license/request_license_using_code', {'identifier': currentIdentifier, 'one_time_pw': salt, 'code': otp})
		.then((license) => {
			const description = profileDescriptionFromLicense(license),
				mmProfile = mindmupProfile(PROVIDER_NAME, description, license);
			authenticationModel.authenticatedProfile(() => mmProfile);
			return mmProfile;
		})
		.catch((reason) => {
			authenticationModel.authenticationFailed();
			throw reason;
		});
	};
};


